import { useState } from "react";
import { type LeadTemplate } from "../../lib/lead-types.ts";
import { getAllLeadTemplates } from "../../lib/lead-storage.ts";

interface Props {
  onUseTemplate: (templateId: string) => void;
}

export function LeadTemplatesCatalog({ onUseTemplate }: Props) {
  const [activeCategory, setActiveCategory] = useState<string>("all");
  const templates = getAllLeadTemplates();

  const filtered = templates.filter((tpl) => {
    if (activeCategory === "all") return true;
    if (activeCategory === "follow_up") return tpl.isFollowUp;
    return tpl.category === activeCategory;
  });

  return (
    <div className="lead-templates-catalog space-y-4">
      <div className="card flex-between">
        <div>
          <h3>Outreach &amp; Follow-Up Templates Catalog</h3>
          <p className="muted text-xs">
            Curated B2B outreach scripts designed for high-response manual founder outreach.
          </p>
        </div>

        {/* Filter chips */}
        <div className="email-category-chips">
          <button
            type="button"
            className={`email-cat-chip ${activeCategory === "all" ? "active" : ""}`}
            onClick={() => setActiveCategory("all")}
          >
            All Templates ({templates.length})
          </button>
          <button
            type="button"
            className={`email-cat-chip ${activeCategory === "expense_management" ? "active" : ""}`}
            onClick={() => setActiveCategory("expense_management")}
          >
            Expense Management
          </button>
          <button
            type="button"
            className={`email-cat-chip ${activeCategory === "saas_pricing" ? "active" : ""}`}
            onClick={() => setActiveCategory("saas_pricing")}
          >
            SaaS PPP Pricing
          </button>
          <button
            type="button"
            className={`email-cat-chip ${activeCategory === "invoicing_payroll" ? "active" : ""}`}
            onClick={() => setActiveCategory("invoicing_payroll")}
          >
            Invoicing &amp; Payroll
          </button>
          <button
            type="button"
            className={`email-cat-chip ${activeCategory === "ecommerce" ? "active" : ""}`}
            onClick={() => setActiveCategory("ecommerce")}
          >
            E-Commerce
          </button>
          <button
            type="button"
            className={`email-cat-chip ${activeCategory === "follow_up" ? "active" : ""}`}
            onClick={() => setActiveCategory("follow_up")}
          >
            Follow-Up Bumps
          </button>
        </div>
      </div>

      <div className="lead-templates-grid">
        {filtered.map((tpl) => (
          <div key={tpl.id} className="card lead-tpl-card">
            <div className="lead-tpl-head">
              <span className={`badge ${tpl.isFollowUp ? "badge-warning" : "badge-accent"} text-xs`}>
                {tpl.isFollowUp ? "Follow-Up" : tpl.category}
              </span>
              <button
                type="button"
                className="btn btn-primary btn-xs"
                onClick={() => onUseTemplate(tpl.id)}
              >
                Use in Composer →
              </button>
            </div>

            <h4 className="lead-tpl-title mt-2">{tpl.name}</h4>
            <p className="lead-tpl-desc text-xs muted">{tpl.description}</p>

            <div className="lead-tpl-subject-box mt-3">
              <span className="text-xs muted block">Subject:</span>
              <span className="text-xs mono text-white">{tpl.subject}</span>
            </div>

            <div className="lead-tpl-body-preview mt-3">
              <div
                className="lead-tpl-html-snippet text-xs"
                dangerouslySetInnerHTML={{ __html: tpl.htmlBody }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
